import {get} from "lodash"
import {css} from "styled-components"

import {type ThemeColorPath} from "../../global/theme"

const getColor = (theme: any, value: ThemeColorPath): string => {
  const {utility} = theme.colors
  switch (value) {
    case "contrast":
      return utility.contrast
    case "subdued":
      return utility.subdued
    case "ink":
      return utility.ink
    case "white":
      return utility.white
    default:
      return get(theme.colors, value) || value
  }
}

const getFontWeight = (theme: any, value: "light" | "medium" | "bold"): string => {
  const {font} = theme

  switch (value) {
    case "light":
      return font.light
    case "medium":
      return font.medium
    case "bold":
      return font.bold
    default:
      return font.default
  }
}

export interface CommonProps {
  noWrap?: boolean
  wordBreak?: "normal" | "break-all" | "break-word" | "keep-all"
  overflow?: "visible" | "hidden" | "scroll" | "auto"
  overflowWrap?: "normal" | "break-word" | "anywhere"
  textDecoration?: "underline" | "line-through" | string
  textAlign?: "left" | "right" | "center" | "justify" | "justify-all" | "start" | "end" | "match-parent" | string
  weight?: "default" | "light" | "semibold" | "bold"
  color?: ThemeColorPath
  display?: "inline" | "block" | "inline-block" | "initial"
  ellipsis?: boolean
}

export const commonCSS = css<CommonProps>`
  ${({noWrap}) => noWrap && `white-space: nowrap;`}
  ${({wordBreak}) => wordBreak && `word-break: ${wordBreak};`}
  ${({overflow}) => overflow && `overflow: ${overflow};`}
  ${({overflowWrap}) => overflowWrap && `overflow-wrap: ${overflowWrap};`}
  ${({textDecoration}) => textDecoration && `text-decoration: ${textDecoration};`}
  ${({textAlign}) => textAlign && `text-align: ${textAlign};`}
  ${({weight, theme}) => weight && `font-family: ${getFontWeight(theme, weight)};`}
  ${({color, theme}) => color && `color: ${getColor(theme, color)};`}
  ${({display}) => display && `display: ${display};`}
  ${({ellipsis}) =>
    ellipsis &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`
